<template>
  <div>
    <v-app-bar app left color="primary">
      <v-app-bar-nav-icon
        :ripple="false"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="font-weight-bold pl-0">
        {{ title }}
        <span v-if="subtitle != ''">
          |
          <span class="font-weight-light">{{ subtitle }}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer
      app
      floating
      clipped-left
      color="primary"
      v-model="drawer"
    >
      <router-link :to="{ path: '/' }">
        <img id="navLogo" src="@/assets/logo.png" />
      </router-link>

      <v-list>
        <v-list-group
          v-for="chapter in chapters"
          :key="chapter.icon"
          :prepend-icon="chapter.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="chapter.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="section in chapter.sections"
            :key="section.route"
            :to="section.route"
            dense
          >
            <!-- @click.stop="subtitle = section.shortname" -->
            <v-list-item-content>
              <v-list-item-title
                v-text="section.name"
                class="pl-2"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  components: {},
  created() {},
  props: {},
  data: () => ({
    drawer: false,
    title: "TACSOP",
    subtitle: "",
    chapters: [
      {
        title: "Soldier & Leader Standards",
        icon: "mdi-numeric-1-circle",
        sections: [
          {
            name: "Packing Lists",
            route: "packinglists",
            shortname: "Packing Lists"
          },
          {
            name: "PCC/PCI Cards",
            route: "pccpcicards",
            shortname: "PCC/PCI Cards"
          },
          { name: "Tie Downs", route: "tiedowns", shortname: "Tie Downs" }
        ]
      },
      {
        title: "Tactical Athlete Program",
        icon: "mdi-numeric-2-circle",

        sections: [
          {
            name: "Physical Readiness Training",
            route: "physicalreadiness",
            shortname: ""
          },
          {
            name: "Tactical Foot Marches",
            route: "footmarches"
          },
          {
            name: "Physical & Combat Fitness Tests",
            route: "fitnesstest",
            shortname: ""
          }
        ]
      },
      {
        title: "Mission Command",
        icon: "mdi-numeric-3-circle",

        sections: [
          { name: "WARNORD", route: "warnord", shortname: "" },
          { name: "CONOP", route: "conop", shortname: "" },
          { name: "OPORD", route: "opord", shortname: "" },
          { name: "FRAGORD", route: "fragord" },
          { name: "Terrain Model Standards", route: "terrain", shortname: "" },
          { name: "RXLs", route: "rxls", shortname: "" },
          { name: "Accountability", route: "accountability", shortname: "" }
        ]
      },
      {
        title: "Maneuver & Unit Operations",
        icon: "mdi-numeric-4-circle",

        sections: [
          { name: "Movement Techniques", route: "movement", shortname: "" },
          {
            name: "Formations & Orders of Movement",
            route: "formations",
            shortname: ""
          },
          {
            name: "Actions on Contact",
            route: "actions"
          },
          { name: "Patrol Base Operations", route: "patrol", shortname: "" }
        ]
      },
      {
        title: "Support",
        icon: "mdi-numeric-5-circle",
        sections: [
          {
            name: "Battle Roster Numbers",
            route: "battleroster",
            shortname: ""
          },
          { name: "CASEVAC", route: "casevac", shortname: "" },
          { name: "Medical Operations", route: "medops", shortname: "" },
          { name: "LOGPAC", route: "logpac", shortname: "" }
        ]
      },
      {
        title: "Reports",
        icon: "mdi-numeric-6-circle",
        sections: [
          {
            name: "Reoccurring Reports",
            route: "recurringreports",
            shortname: ""
          },
          {
            name: "Sensitive Item Report",
            route: "sensitivereports",
            shortname: ""
          },
          { name: "AAR Format", route: "aar", shortname: "" }
        ]
      },
      {
        title: "Safety",
        icon: "mdi-numeric-7-circle",
        sections: [
          {
            name: "Composite Risk Management",
            route: "riskmanagement",
            shortname: ""
          },
          {
            name: "Hot/Cold Illness Prevention",
            route: "heat",
            shortname: ""
          },
          {
            name: "Field Hygiene and Sanitation",
            route: "fieldhygiene",
            shortname: ""
          }
        ]
      },
      {
        title: "Range Operations",
        icon: "mdi-numeric-8-circle",
        sections: [
          { name: "Range Operations", route: "rangeOps", shortname: "" }
        ]
      },
      {
        title: "Weapon Safety",
        icon: "mdi-numeric-9-circle",
        sections: [
          { name: "Weapon Safety Doc", route: "weaponsafetydoc", shortname: "" },
          { name: "Weapon Clearing Procedures", route: "weaponClearing", shortname: "" }
        ]
      }
    ]
  })
};
</script>

<style>
#navLogo {
  margin: 1.5rem auto 0;
  padding: 0 3.5rem;
  width: 100%;
}

/* Hiddens Caret and Removes Left Margin from Chapter Names */
.v-list-item__icon.v-list-group__header__append-icon > i {
  display: none;
  margin-left: 0;
}

/* Reveals Hidden Overflow for Chapter Names */
.v-list-item__content {
  overflow: visible !important;
}

/* Adjusts Margin on Prepended Chapter Name Icons */
.v-list-item__icon {
  margin: auto 8px auto 4px !important;
}

.v-list-group__header {
  padding: 0 4px !important;
  color: #fff !important;
}

/* Corrects Text Color */
.v-list-item {
  color: #fff !important;
}

.v-list-item.v-list-item--link.theme--dark {
  padding-left: 8px !important;
}
</style>
